"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
const text_input_1 = require("@uxf/ui/text-input");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const form_id_context_1 = require("../form-id-context");
function NumberInput(props) {
    var _a, _b, _c, _d, _e;
    const formId = (0, form_id_context_1.useFormIdContext)();
    const id = (_a = props.id) !== null && _a !== void 0 ? _a : `${formId}__${props.name}`;
    const { field, fieldState } = (0, react_hook_form_1.useController)({
        control: props.control,
        defaultValue: props.defaultValue,
        name: props.name,
        rules: {
            max: typeof props.max === "number" && !isNaN(props.max)
                ? {
                    value: props.max,
                    message: `Hodnota musí být nižší než ${props.max}.`,
                }
                : undefined,
            min: typeof props.min === "number" && !isNaN(props.min)
                ? {
                    value: props.min,
                    message: `Hodnota musí být vyšší než ${props.min}.`,
                }
                : undefined,
            required: props.isRequired ? props.requiredMessage || "Toto pole je povinné" : undefined,
            ...((_b = props.rules) !== null && _b !== void 0 ? _b : {}),
        },
        shouldUnregister: props.shouldUnregister,
    });
    const onBlur = (event) => {
        var _a;
        field.onBlur();
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    const onKeyDown = (event) => {
        var _a;
        // Allow special keys
        const specialKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        // Allow keys for copy/paste/select/cut
        const controlKeys = ["v", "V", "c", "C", "x", "X", "a", "A"];
        // Allow digits and decimal point (.,)
        const allowedDigits = /[0-9+\-.,]/;
        const key = event.key;
        // Check if the key is allowed
        if (!specialKeys.includes(key) && !allowedDigits.test(key)) {
            // Check if Ctrl or Command key is pressed along with control key
            if (!(event.ctrlKey || event.metaKey) || !controlKeys.includes(key)) {
                event.preventDefault();
            }
        }
        (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    const onChange = (value, event) => {
        var _a;
        const parsedValue = props.decimalPlaces ? parseFloat(value) : parseInt(value, 10);
        const returnValue = isNaN(parsedValue) ? null : parsedValue;
        field.onChange(returnValue);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, returnValue, event);
    };
    return (react_1.default.createElement(text_input_1.TextInput, { autoComplete: props.autoComplete, autoFocus: props.autoFocus, className: props.className, enterKeyHint: props.enterKeyHint, form: props.form, helperText: (_d = (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : props.helperText, hiddenLabel: props.hiddenLabel, id: id, inputMode: props.decimalPlaces ? "decimal" : "numeric", isDisabled: props.isDisabled, isInvalid: !!fieldState.error, isReadOnly: props.isReadOnly, isRequired: props.isRequired, label: props.label, leftAddon: props.leftAddon, leftElement: props.leftElement, max: props.max, min: props.min, name: field.name, onBlur: onBlur, onChange: onChange, onFocus: props.onFocus, onKeyDown: onKeyDown, pattern: props.pattern, placeholder: props.placeholder, step: props.decimalPlaces ? Number(0).toFixed(props.decimalPlaces - 1) + "1" : props.step, ref: field.ref, rightAddon: props.rightAddon, rightElement: props.rightElement, size: props.size, type: "number", value: (_e = field.value) !== null && _e !== void 0 ? _e : "", variant: props.variant }));
}
exports.NumberInput = NumberInput;
NumberInput.displayName = "UxfFormNumberInput";
